import DateFlexibility from "$/_const/trip/DateFlexibility.ts";
import type { TripData } from "$/models/Trip.model.ts";

type TripDateSelection = Pick<
  TripData,
  | "arrival_date"
  | "departure_date"
  | "duration"
  | "can_modify_arrival_or_departure_dates"
>;

const shouldCollectBookings = (
  trip: TripDateSelection | null | undefined,
): boolean =>
  Boolean(
    trip?.arrival_date &&
      trip.departure_date &&
      trip.duration === undefined &&
      trip.can_modify_arrival_or_departure_dates ===
        DateFlexibility.EXACT_DATES,
  );

export default shouldCollectBookings;
